import React from "react";
import { Typography, Row, Col } from "antd";
import { friendlyPrice } from "../../../utils/calculators";

const { Text } = Typography;

const SubscriptionTotal = props => {
    const { subtotal, discount, tax, total, billingPeriod } = props;
    return (
        <div style={{ fontSize: "1rem" }}>
            <Row type="flex" justify="space-between" align="middle" style={{ padding: "2px 0" }}>
                <Col>
                    <div>
                        <Text>{"Subtotal:"}</Text>
                    </div>
                </Col>
                <Col>
                    <Text>{`${friendlyPrice(subtotal)}`}</Text>
                </Col>
            </Row>
            {discount > 0 && (
                <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    style={{ padding: "2px 0" }}
                >
                    <Col>
                        <div>
                            <Text>{"Discount:"}</Text>
                        </div>
                    </Col>
                    <Col>
                        <Text>{`-${friendlyPrice(discount)}`}</Text>
                    </Col>
                </Row>
            )}
            <Row type="flex" justify="space-between" align="middle" style={{ padding: "2px 0" }}>
                <Col>
                    <div>
                        <Text>{"Est. Tax:"}</Text>
                    </div>
                </Col>
                <Col>
                    <Text>{`${friendlyPrice(tax)}`}</Text>
                </Col>
            </Row>
            <Row type="flex" justify="space-between" align="middle" style={{ padding: "2px 0" }}>
                <Col>
                    <div>
                        <Text>{"Monthly total:"}</Text>
                    </div>
                </Col>
                <Col>
                    <Text>{`${friendlyPrice(total / billingPeriod)}`}</Text>
                </Col>
            </Row>
            <Row type="flex" justify="space-between" align="middle" style={{ padding: "2px 0" }}>
                <Col>
                    <div>
                        <Text strong>{"Total due today:"}</Text>
                    </div>
                </Col>
                <Col>
                    <Text strong>{`${friendlyPrice(total)}`}</Text>
                </Col>
            </Row>
        </div>
    );
};

export default SubscriptionTotal;
